import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import { removeEmptyParams } from 'utils/services';

import {
  ApiResponse,
  adaptApiToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import type { ClientDto } from './dto';
import { mapClientDtoToModel, mapClientListDtoToModel } from './mappers';
import type { Client, ClientsListParams } from './models';

const CLIENTS_LIST_PATH = '/management/clients';
const CLIENT_BY_ID_PATH = '/management/clients/client';

const CLIENTS_ERROR_MESSAGE =
  'No cuenta con clientes registrados en el sistema.';

export const getClients = async (
  params: ClientsListParams,
): Promise<GenericResponse<ApiResponse<Client[]>>> => {
  try {
    const queryParams: Record<string, unknown> = {
      page: params.page,
      pageSize: params.pageSize,
      order: params.order ?? 'name',
      filterBy: params.filterBy,
      filterValue: params.filterValue,
      status: params.status,
    };
    removeEmptyParams(queryParams);

    const response = await wtClientApi.get<ApiResponse<ClientDto[]>>(
      CLIENTS_LIST_PATH,
      { params: queryParams },
    );

    const mappedData = mapClientListDtoToModel(response.data.data ?? []);

    const mappedResponse: ApiResponse<Client[]> = {
      ...response.data,
      data: mappedData,
    };

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(error, CLIENTS_ERROR_MESSAGE);
  }
};

export const getClientById = async (
  clientId: number,
): Promise<GenericResponse<ApiResponse<Client>>> => {
  try {
    const response = await wtClientApi.get<ApiResponse<ClientDto>>(
      `${CLIENT_BY_ID_PATH}/${clientId}`,
    );

    const mappedData = mapClientDtoToModel(response.data.data);
    const mappedResponse: ApiResponse<Client> = {
      ...response.data,
      data: mappedData,
    };

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(error, CLIENTS_ERROR_MESSAGE);
  }
};
